// Run score (plan §3.9). Skill-weighted: rewards kills, damage, survival time, boss
// kills and character level, with a victory bonus for reaching the run length. Pure +
// deterministic so it's unit-testable and the server can sanity-check it.

export interface ScoreInputs {
  kills: number;
  damageDealt: number;
  seconds: number;
  bossKills: number;
  level: number;
  victory: boolean;
}

export const VICTORY_BONUS = 5000;

export function computeScore(s: ScoreInputs): number {
  const base = Math.floor(
    s.kills * 10 + s.damageDealt * 0.1 + s.seconds * 5 + s.bossKills * 500 + s.level * 25,
  );
  return Math.max(0, base + (s.victory ? VICTORY_BONUS : 0));
}
